import React, { Children } from "react";
import { Flex, Card, Input, Divider, Tabs } from "antd";
import { SettingOutlined, EditOutlined, EllipsisOutlined, ShoppingOutlined, BarcodeOutlined, LinkOutlined } from "@ant-design/icons";

import MyShopList from "./my-list";

export default ({accId}) => {
    const [myShops, setMyShops] = React.useState([]);

    React.useEffect(() => {
        getMyShops().then(res => {
            setMyShops(res);
        });
    }, []);

    const getMyShops = async () => {
        let response = await fetch(`/api/shop/my-permission-list`);
        let result = await response.json();

        if(result && result.success) {
            return result.data;
        }

        return [];
    }

    return (
        <div>
            <h2 className="admin-page-title">店铺列表</h2>
     
            <MyShopList list={myShops} />
        </div>
   );
};
